import EventNoteIcon from '@mui/icons-material/EventNote'
import { Box, InputBase, Typography, IconButton, Stack } from '@mui/material'
import { PaymentData } from '@src/data/types/PaymentData'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { useTranslation } from 'react-i18next'
import { formatDays } from '@src/services/Formatter';

interface PaymentDashboardProps {
  paymentInfo?: PaymentData | null
  selectedDate: Date | null
  onDateChange: (date: Date | null) => void
  maxDate: Date | null
  closedNextPayment?:boolean
}

const PaymentDashboard = ({ paymentInfo, selectedDate, onDateChange,maxDate,closedNextPayment }: PaymentDashboardProps) => {
  const { t,     i18n: { resolvedLanguage }, } = useTranslation()
  const today = new Date()

  const calculateDays = (nextPaymentDateUTC: string) => {
    const nextPaymentDate = new Date(nextPaymentDateUTC)
    const timeDifference = nextPaymentDate.getTime() - today.getTime()
    const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24))

    return daysDifference === 0 ? t('payment.today') : `${daysDifference} ${t('payment.days')}`
  }
  interface CustomInputProps {
    value?: string;
    onClick?: () => void;
  }
  
  const CustomInput = ({ value, onClick }: CustomInputProps) => (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      position: 'relative',
      borderBottom: '1px solid white', 
    }}>
      <InputBase
        readOnly
        value={value}
        onClick={onClick}
        placeholder={t('payment.dateHolder')}
        sx={{
          fontSize: '1rem',
          fontWeight: '200',
          color: 'white',
          textAlign: 'left',
          backgroundColor: 'transparent',
          width: '100%',
          pr: '3rem',
        }}
      />
      <IconButton sx={{
        color: 'white',
        position: 'absolute',
        right: 0,
        top: '50%',
        transform: 'translateY(-50%)',
      }} onClick={onClick}>
        <EventNoteIcon />
      </IconButton>
    </Box>
  );
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column'}}> 
      {paymentInfo && closedNextPayment && (
        <>
       <Typography  sx={{ fontWeight: 200, mb: 1 }}>  
               {t('payment.nextPayment')}
        </Typography>
          <Box sx={{ color: 'gray' }}>{formatDays(paymentInfo.plannedOnDateUTC, resolvedLanguage)}</Box>
             <Box key={paymentInfo.id} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>  
           <Stack spacing={2}>  
             <Typography component="div" sx={{ fontWeight: 200, mb: 1 }}>  
               <Box component="span" sx={{ fontSize: '4rem', color: 'white' }}>{Math.floor(paymentInfo.amount)}</Box>
             <Box component="span" sx={{ fontSize: '4rem', color: 'gray' }}>.{(paymentInfo.amount % 1).toFixed(2).split('.')[1]}$</Box>
               <Box component="span" sx={{ color: 'gray' }}> / {t('payment.month')}</Box>
             </Typography>
             <Box sx={{ display: 'flex', alignItems: 'center', color: 'white', fontWeight: 200,mt:0 }}>
            </Box>
          </Stack>
      </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', mt: -2 }}>
            <EventNoteIcon sx={{ mr: 1 }} /> 
            <Typography  sx={{ fontWeight: 200 }}>{calculateDays(paymentInfo.plannedOnDateUTC)}</Typography>
          </Box>
        </>
      )}
      <Box className="new-date-picker"> 
        <Typography  sx={{ fontWeight: 200, mb: 1,mt: 3 }}>  
        {t('payment.chooseNewDate')}
          </Typography>
        <Box sx={{ mt: 2,mb: 3}}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            minDate={today}
            maxDate={maxDate || undefined}
            value={selectedDate}
            onChange={onDateChange}
            format="dd/MM/yyyy"
            slots={{ textField: () => <CustomInput /> }}
          />
        </LocalizationProvider>
        </Box>
      </Box>
    </Box>
  )
}
export default PaymentDashboard
